import { createContext, useContext } from 'react';
import { makeProvider } from 'lib/custom-hooks/make-custom-hook-provider';

export const CustomHeaderComponentContext = createContext([() => null, () => {}]);
export const CustomHeaderComponentProvider = makeProvider(CustomHeaderComponentContext);
export const useCustomHeaderComponent = () => useContext(CustomHeaderComponentContext);

export const CustomHeaderPropsContext = createContext([
  {
    isAffixed: false,
    customTreeFilter: {},
    isGridView: false,
    handleViewToggle: () => {},
  },
  () => {},
]);
export const CustomHeaderPropsProvider = makeProvider(CustomHeaderPropsContext);
export const useCustomHeaderProps = () => useContext(CustomHeaderPropsContext);
